import { IProductDefinitionList, NodeObjectRepository } from '@/models/assembly';

export const GordionSehpa = {
  'gordion-sehpa': {
    steps: [
      {
        order: 1,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {
          const ayak = repository.get('gordion_sehpa_ayak_arc29_yyy')
            .show();



          repository.track(ayak);
        },
      },
      {
        order: 2,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const ayak = repository.get('gordion_sehpa_ayak_arc29_yyy')
            .resetRotation([1, 0, 0]);


          const laminant = repository.get('gordion_laminan_tb_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, 1.1, 'easeInCubic');




          laminant.show();
          laminant.resetPosition(1.5);

          repository.track(ayak, laminant);
        },
      },

      {
        order: 3,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {


          const vida = repository.get('m6x_12_ysb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 25,
              };
            }, 1.1, 'easeInCubic');



          vida.show();
          vida.resetPosition(1.5);

          repository.track(vida);
        },
      },
      {
        order: 4,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {
          const kece = repository.get('gordion_sehpa_kece_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y - 50,
            };
          }, 1.1, 'easeInCubic');
          kece.show();
          kece.resetPosition(1.5);

          repository.track(kece);

        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/gordion-sehpa.ts